// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fVtcw{color:#d4d4e0;background:#282863;box-shadow:0px 4px 24px rgba(40,40,99,.12);width:200px;min-width:200px;max-width:200px;height:100%;display:flex;flex-direction:column;border-radius:0 24px 0 0;padding:0 12px;overflow:auto}.KecGl{display:inline-block}.fFj8g{padding:16px 4px 6px}.KkyFs{flex:1;overflow-y:auto;padding:6px 0 12px;border-bottom:1px solid #535382;display:flex;flex-direction:column;gap:2px}.cBpye{padding:12px 0;display:flex;flex-direction:column}.udq9M{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em;padding:8px;border:0;border-radius:8px;color:#d4d4e0;display:flex;align-items:center;justify-content:space-between;width:100%;text-align:start;background:transparent;transition:background .2s,color .2s,max-height .2s ease-in-out,opacity .2s ease-in-out,padding .2s ease-in-out,margin .2s ease-in-out;cursor:pointer;opacity:1;max-height:200px}.udq9M[disabled]{color:#9393b1}.udq9M[disabled] .Qvm0u,.udq9M[disabled] .Eycvz,.udq9M[disabled] .M7fGT{color:inherit}.udq9M:hover:not([disabled]){background:#535382;color:#fff}.udq9M.uaEti{background:#696992;color:#fff}.YJzNa.Ha9ZT .udq9M{max-height:0px;overflow:hidden;padding-top:0px;padding-bottom:0px;margin-top:0px;opacity:0}.Qvm0u,.Eycvz,.M7fGT{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em;color:inherit;display:flex}.Qvm0u{display:inline-block;flex:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Eycvz{margin-right:12px}.M7fGT{font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em;margin-left:16px}.JRiBF{transform:rotate(180deg);transition:transform .2s ease-in-out}.YJzNa.Ha9ZT .JRiBF{transform:rotate(0deg)}.aiTh2{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em;padding:8px;border:0;border-radius:8px;color:#d4d4e0;flex-direction:row;display:flex;align-items:center;justify-content:space-between;width:100%;text-align:start;background:transparent;transition:background .2s,color .2s;cursor:pointer}.aiTh2:hover{background:#535382;color:#fff}.YJzNa:not(.Ha9ZT)>.aiTh2:hover{background:transparent;color:#d4d4e0}.YJzNa{display:flex;flex-direction:column}.YJzNa>.udq9M{padding-left:16px;margin-top:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `fVtcw`,
	"wrapper": `KecGl`,
	"header": `fFj8g`,
	"content": `KkyFs`,
	"footer": `cBpye`,
	"item": `udq9M`,
	"itemContent": `Qvm0u`,
	"itemPrefix": `Eycvz`,
	"itemSuffix": `M7fGT`,
	"active": `uaEti`,
	"group": `YJzNa`,
	"collapsed": `Ha9ZT`,
	"groupChevron": `JRiBF`,
	"groupToggle": `aiTh2`
};
export default ___CSS_LOADER_EXPORT___;
